// extracted by mini-css-extract-plugin
module.exports = {"container":"Swipable_container__WeNix","swipable":"Swipable_swipable__1Osjg","offscreen":"Swipable_offscreen__bt5Xj"};